import React, { createContext, useContext, useState } from 'react';

// Create context
const SelectedDateMatchProbContext = createContext();

// Provider component
export const SelectedDateMatchProbProvider = ({ children }) => {
  const [selectedDate, setSelectedDate] = useState(new Date()); // Default to current date

  return (
    <SelectedDateMatchProbContext.Provider value={{ selectedDate, setSelectedDate }}>
      {children}
    </SelectedDateMatchProbContext.Provider>
  );
};

// Custom hook for easy access to the context
export const useSelectedDate = () => useContext(SelectedDateMatchProbContext);
